import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import FlashLib from 'flashlib_onlyplay';
import animationTypes from '../enums/eAnimationTypes';
import animationCreator from 'Engine/animations/animationCreator';
import eSymbolIndex from './eSymbolIndex';

export default class SymbolAnimation extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);
    this.animationNames = {
      [eSymbolIndex.ESI_OWL]: 'owl_1',
      [eSymbolIndex.ESI_FOX]: 'fox_1',
      [eSymbolIndex.ESI_BUTTERFLY]: 'butterfly_1',
      [eSymbolIndex.ESI_UNICORN]: 'unicorn_1',
      [eSymbolIndex.ESI_JUG]: 'jug_1',
      [eSymbolIndex.ESI_HORSE_SHOE]: 'horse_shoe_1',
      [eSymbolIndex.ESI_RABBIT]: 'rabbit_1',
      [eSymbolIndex.ESI_LOTUS]: 'lotus_1',
      [eSymbolIndex.ESI_SCATTER]: 'free_spin_1',
    };

    this.stopAnimationNames = {
      [eSymbolIndex.ESI_SCATTER]: 'free_spin_1',
    };

    this.onComplete = () => {};
    this.onStart = () => {};

    this.animationListener = {
      start: this.onStart.bind(this),
      complete: this._complete.bind(this),
    };

    this.cycleListener = { complete: this._cycle.bind(this) };

    this.animation = null;
    this.init();
    this.addListeners();
  }

  init() {
    this.animation = animationCreator.createAnimation(animationTypes.SYMBOLS);
    this.animation.visible = false;
    this.animation.state.addListener(this.animationListener);
    this.addChild(this.animation);
  }

  addListeners() {
    GlobalDispatcher.add('stateStart:jackpotGameInState', () => this.isActive = this.animation.visible, this);
    GlobalDispatcher.add('stateStart:jackpotGameOutState', () => this.animation.visible = this.isActive, this);
  }

  start(loop) {
    this._playSpineAnimation(loop);
  }

  stop() {
    if (this.animation) {
      this._completeCycle();
      this.animation.visible = false
    }
  }

  startStopAnimation() {
    this.animation.visible = true;
    this.animation.skeleton.setToSetupPose();
    this.animation.state.setAnimation(0, this.stopAnimationNames[this.id], false);

    this.animation.state.addListener(this.cycleListener);
  }

  _playSpineAnimation(loop) {
    this.animation.visible = true;
    this.animation.state.setAnimation(0, this.animationNames[this.id], loop);
  }

  _complete() {
    // this.animation.visible = false;
    this.onComplete();
    // this.emit('animationComplete', this);
  }

  _cycle() {
    this._cycleTimeout = setTimeout(() => {
      this.animation.state.setAnimation(0, this.stopAnimationNames[this.id], false);
    }, 1250);
  }

  _completeCycle() {
    clearTimeout(this._cycleTimeout);
    this.animation.state.removeListener(this.cycleListener);
  }
}
